<div class="title">
  @if (supTitle) {
    <app-small-title>{{ supTitle }}</app-small-title>
  }
  @switch (tag) {
    @case ('h1') {
      <h1 [class]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </h1>
    }
    @case ('h2') {
      <h2 [class]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </h2>
    }
    @case ('h3') {
      <h3 [class]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </h3>
    }
    @case ('h4') {
      <h4 [class]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </h4>
    }
    @case ('h5') {
      <h5 [class]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </h5>
    }
    @case ('h6') {
      <h6 [class]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </h6>
    }
  }
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
